export enum DataHooks {
  ROOT = 'book-button-root',
  BUTTON = 'book-button-button',
  SPINNER = 'book-button-spinner',
}
